// extracted by mini-css-extract-plugin
export default {"Facilities":"facilities_Facilities__g-vTM","Slogan":"facilities_Slogan__osbv9","LandingContent":"facilities_LandingContent__kOJSC"};